import { NameValue } from '@infodata-group/inf-commons';

export class NameValueOperator extends NameValue {
  public operator: '>' | '<' | '' = '';

  constructor(name: string, value: string, operator: '>' | '<' | '' = '') {
    super(name, value);
    this.operator = operator;
  }

  public toNameValue(): NameValue {
    return new NameValue(
      `WITH[]=${this.name}|${this.operator}`,
      `|${this.value}`,
    );
  }
}
